import React from 'react'
import AdminHeader from '../components/Layout/AdminHeader'
import AdminSideBar from '../components/Admin/Layout/AdminSideBar'
import AllSellers from "../components/Admin/AllSellers";

const AdminDashboardSellers = () => {
  return (
    <div className="dashboard-page-wrapper">
      <AdminHeader />
      <div className="dashboard-flex-wrapper">
        <div className="w-[80px] 800px:w-[330px] dashboard-sidebar">
          <AdminSideBar active={3} />
        </div>
        <div className="dashboard-main-content flex-1">
          <AllSellers />
        </div>
      </div>
    </div>
  )
}

export default AdminDashboardSellers